import { CSSObject } from '@chakra-ui/react';

export const IconContainer: CSSObject = {
  display: 'none',
};

export const Icon: CSSObject = {
  ml: 'unset',
  color: 'gamma.500',
};

export const MatchCardContainer: CSSObject = {
  bg: 'alpha.400',
  display: 'grid',
  alignItems: 'center',
  gridTemplateColumns: '1fr 40px',
  gridTemplateRows: '1fr',
  gridTemplateAreas: `
    "matchInfo arrowIcon"
  `,
  boxShadow: 'sm',
  borderBottom: '1px solid',
  borderBottomColor: 'alpha.500',
  w: '100%',
  px: '2',
  py: '1.5',

  _hover: {
    bg: 'alpha.500',
  },
};

export const MatchName: CSSObject = {
  fontWeight: 'semibold',
  fontSize: ['sm', null, 'md'],
};

export const MatchDate: CSSObject = {
  fontSize: 'xs',
  fontWeight: 'extrabold',
  color: 'whiteAlpha.800',
};

export const TeamItemOdds: CSSObject = {
  color: 'yellow.900',
  fontWeight: 'semibold',
  fontSize: 'sm',
};

export const VersusText: CSSObject = {
  display: 'block',
  fontSize: 'md',
  fontWeight: 'semibold',
  color: 'yellow.900',
};

export const Versus: CSSObject = {
  display: 'flex',
  position: 'absolute',
  borderRadius: 'full',
  boxSize: '12',
  bg: 'yellow.600',
  border: '3px solid',
  borderColor: 'yellow.400',
  boxShadow: '0px 1px 20px 0px #00000080',
  color: 'yellow.900',
  left: '50%',
  transform: 'translate(-50%, 0)',
  top: '84px',

  alignItems: 'center',
  justifyContent: 'center',
};

export const TeamsContainer: CSSObject = {
  flexDir: 'row',
  flex: '1',
  display: 'flex',
  mt: '0',
};

export const TeamItem: CSSObject = {
  border: 'none',
  bg: 'yellow.400',
  '&&': { textColor: 'yellow.900', h: '8' },
  _hover: {
    boxShadow: '0 1px 2px 1px black',
    transform: 'translateY(-3%)',
  },
};

export const TeamItemName: CSSObject = {
  fontSize: 'sm',
  color: 'white',
  mb: '1.5',
  fontWeight: 'semibold',
};

export const Seperator: CSSObject = {
  color: 'whiteAlpha.800',
  mx: '0',
  px: '0',
};
export const NameContainer: CSSObject = {
  gridTemplateColumns: '70px 1fr 40px',
  gridTemplateRows: '1fr',
  gridTemplateAreas: `
  "icon matchInfo arrowIcon"
`,
};

export const TextSpanName = (): CSSObject => ({
  color: 'white',
});

export const CompetitionName: CSSObject = {
  fontSize: 'xs',
  fontWeight: 'extrabold',
  color: 'whiteAlpha.800',
};

export const ArrowIcon: CSSObject = {
  boxSize: '7',
  color: 'white',
  border: '1px',
  borderColor: 'white',
  borderRadius: 'full',
};

export const MatchDetails: CSSObject = {
  py: '0',
};

export const BodyContainer: CSSObject = {
  py: '1',
};
